// sagas/closureSaga.js
import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_BASELINE_MARKET_DETAILS_REQUEST,
  submitBaselineMarketDetailsSuccess,
  submitBaselineMarketDetailsFailure,
} from "../actions/baselineMarketDetailsActions";
import { getBaselineMarketDetails } from "../../../services/accIqService";

// Saga function
function* handleBaselineMarketDetailsSubmission(action) {
  try {
    const response = yield call(
      getBaselineMarketDetails,
      action.payload.client,
      action.payload.company
    );
    yield put(
      submitBaselineMarketDetailsSuccess(
        response?.data || "No baseline market details generated."
      )
    );
  } catch (error) {
    yield put(submitBaselineMarketDetailsFailure(error.error));
  }
}

export function* watchBaselineMarketDetailsSubmission() {
  yield takeLatest(
    SUBMIT_BASELINE_MARKET_DETAILS_REQUEST,
    handleBaselineMarketDetailsSubmission
  );
}
